import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, OnChanges, Renderer2 } from '@angular/core';

import * as echarts from 'echarts';
import EChartOption = echarts.EChartOption;
import { Data } from '../../models';
import { CoreService, HttpService } from '../../services';
declare var $: any;
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'quest-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit, OnChanges {
  @ViewChild('graph', { static: false }) graph: ElementRef;
  myChart: any;
  /* @ViewChild('chart') cavnasChart: ElementRef;
   public ChartLegend = true;
   public Type: string;
   public ChartOptions: any;
   private Chart: any;
   private ChartLabel: any;*/

  @Input() ChartLabels: string[];
  @Input() ChartData: Data;
  @Input() ChartColor = 0;
  @Input() ChartType: string;
  @Input() Element: string;
  @Input() noteMax: number;

  @Input() IdChart: string = '#graphDiv';
  data: any[];
  myColors: any[];


  constructor(protected IndParam: CoreService,
    protected http: HttpService,
    protected renderer: Renderer2) { }


  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (this.ChartData && this.ChartData.data.length > 0) {
      this.myChart.resize();
    }
  }


  ngOnInit() {
    if (this.myChart)
      this.myChart.resize();
    /* switch (this.ChartType) {
       case 'CHECKLISTE':
       case 'RADIOLISTE':
       case 'CHECKLISTENOTEQUESTION':
       case 'RADIOLISTEPNOTEQUESTION':
         this.bar();
         break;
       case 'TEXTBOX':
         break;
       case 'SATISFACTION':
         this.line();
         break;
       default:
         this.default();
         break; 
     }
  
  
     this.data = [{ data: this.ChartData.data, label: this.ChartData.label }, ];*/
  }


  ngOnChanges(): void {
    if (this.ChartData.data.length > 0) {
      const style: CSSStyleDeclaration = getComputedStyle(document.body);
      const Cmain: string = style.getPropertyValue('--c-main');
      const Csecondary: string = style.getPropertyValue('--c-secondary');
      const clightmain: string = style.getPropertyValue('--c-light-main');
      const noteMax = this.noteMax;
      /*   this.dialogservice.showSplash(true);*/

      const zoomMaxValue: number = this.ChartData.data.length > 21 ? Math.ceil(2000 / this.ChartData.data.length) : 100;


      setTimeout(() => {
        this.myChart = echarts.init(this.graph.nativeElement);
        this.myChart.setOption({
          grid: {
            left: 25,
            top: 25,
            right: 0,
            bottom: 50
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'category',
            data: this.ChartLabels,
            axisLabel: {
              /* interval: 0,*/
              formatter: function (value: string, index: number) {
                if (value.length > 10) {
                  value = value.substring(0, 10) + '...';
                }
                return value;
              }
            }
          },
          yAxis: {
            type: 'value',
            min: 0,
            /* max: this.AvancementChapitreEL.NbApprenant,*/
          },
          dataZoom: [
            {
              show: this.ChartData.data.length > 21,
              start: 0,
              end: zoomMaxValue,
              bottom: '10px',
              height: '20px',
              right: '1%'
            }
          ],
          series: [{
            data: this.ChartData.data,
            type: 'bar',
            itemStyle: {
              normal: {
                color: function (item: any, index: any) {
                  if (parseInt(item.name) > noteMax) {
                    return '#FFD700';
                  } else {
                    return Cmain;
                  }
                },
                borderWidth: 3,
                borderColor: '#ffffff'
              },
              emphasis: {
                borderWidth: 3,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                show: true,
                position: 'inside'
              }
            }
          }]
        });
      }, 1);



      const interval = setInterval(() => {
        const width = $(this.IdChart.includes("#") ? `${this.IdChart}`:`#${this.IdChart}`).width();
        const height = $(this.IdChart.includes("#") ? `${this.IdChart}` : `#${this.IdChart}`).height();
        if (width > 0 && height > 0) {
          this.renderer.setStyle(this.graph.nativeElement, 'width', `${width}px`);
          this.renderer.setStyle(this.graph.nativeElement, 'height', `${height}px`);
          this.myChart.resize();
          clearInterval(interval);
        }
      }, 100);
    }

  }
}
